﻿import ImageRenderer from "./Renderers/ImageRenderer.class";
import TemplatedDocumentRenderer from "./Renderers/TemplatedDocumentRenderer.class";

export default class ApiDocumentsDom {
	constructor() {
		this.CLASS_HEADER = "resources-block-title";
		this.CLASS_GROUPCONTAINER = "document-group component-resourcesBlock";
		this.templatedRenderer = new TemplatedDocumentRenderer();
		this.$contentDiv = null;
		this.renderers = [new ImageRenderer(), this.templatedRenderer];
	}

	getContentDiv($module) {
		if (!this.$contentDiv) {
			this.$contentDiv = $module.closest("[xyl-tab-content]");
		}
		return this.$contentDiv;
	}

	createHeader(text) {
		const $header = document.createElement("h3");
		$header.className = this.CLASS_HEADER;
		$header.innerText = text;

		return $header;
	}

	createGroupContainer() {
		const $groupContainer = document.createElement("div");
		$groupContainer.className = this.CLASS_GROUPCONTAINER;

		return $groupContainer;
	}

	getDocumentLi(document) {
		var $element = null;

		this.renderers.forEach((renderer) => {
			if (renderer.canRender(document)) {
				$element = renderer.render(document);
			}
		});

		if (!$element) {
			$element = this.templatedRenderer.render(document);
		}

		return $element;
	}
}
